<style lang="less" rel="stylesheet/less" scope>
  .custom {
    position: fixed;
    bottom: 138px;
    right: 30px;
    background-color: #FFFFFF;
    z-index: 3;
    .custom_top {
      display: inline-block;
      cursor: pointer;
      box-shadow: 0 2px 16px #bec2cd, 0 0 1px #bec2cd, 0 0 1px #bec2cd;
      img {
        margin: 0;
        border: 0;
        vertical-align: middle;
      }
    }
    .custom_bottom {
      text-align: center;
      border: 1px solid #dddddd;
      margin-top: 5px;
      padding-bottom: 10px;
      box-shadow: 0 2px 16px #bec2cd, 0 0 1px #bec2cd, 0 0 1px #bec2cd;
      span {
        display: inline-block;
        width: 100%;
        height: 125px;
        margin-top: 10px;
        background: url("./../../assets/login/ERWEIMA.png") center no-repeat;
        background-size: contain;
      }

    }
  }
  @media screen and (min-width: 1024px) and (max-width: 1400px) {
    .custom {
      bottom: 80px;
      .custom_top {
        width: 103px;
        height: 40px;
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
      .custom_bottom {
        margin-top: 5px;
        padding-bottom: 10px;
        font-size: 10px;
        span {
          height: 85px;
          margin-top: 10px;
        }
      }
    }
  }

  @media screen and (min-width: 900px) and (max-width: 1020px) {
    .custom {
      .custom_top {
        width: 103px;
        height: 40px;
        img {
          width: 100%;
          vertical-align: middle;
        }
      }
      .custom_bottom {
        margin-top: 5px;
        padding-bottom: 10px;
        span {
          height: 85px;
          margin-top: 10px;
        }
      }
    }
  }
</style>
<template>
  <div class="custom">
    <p class="custom_top"  id="custom_link" @click="handleChat">
      <!-- <img v-if="objApi.styleColor === 'black'" src="./../../assets/login/qiyu-black.png" alt="客服">
      <img v-else-if="objApi.styleColor === 'blue'" src="./../../assets/login/qiyu-blue.png" alt="客服"> -->
      <img src="./../../assets/login/qiyu.png" alt="客服">
    </p>
    <!--<p class="custom_bottom">-->
      <!--<span></span>-->
      <!--扫描二维码关注-->
    <!--</p>-->
  </div>
</template>
<script type='text/ecmascript-6'>
  export default {
    name: 'LyCustomerBoard',
    computed: {
      objApi() {
        return this.$store.getters.objApi
      }
    },
    methods: {
      handleChat () {
        let { objApi } = this.$store.getters;
        this.$openService(objApi.PLATFORM_NAME || '大装备一体化管理服务云平台', objApi.PLATFORM_NAME || '大装备一体化管理服务云平台');
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/customer-board/index.vue